/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import formSubmitStyle from "@/src/components/Form/Common/FormSubmit/formSubmitStyle";
import { scrollToAnchor } from "@/src/theme/commonStyle";

const summaryStyle ={
  subHeadline: {
    marginTop: "2rem",
    borderBottom: "1px solid #333",
    "& h6": {
      lineHeight: "1rem",
    },
  },
  question: {
    marginTop: "1rem",
    fontWeight: 700,
  },
  ...formSubmitStyle,
  questionsTextArea: {
    margin: "2rem 0",
  },
  scrollToAnchor,
};

export default summaryStyle;
